module.exports = __webpack_public_path__ + "static/media/icon-report-collapse-show.db5aa1eb.svg";